// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SqsI3","clinicsSelect":"styles_clinicsSelect___Y43V"};